import $store from '../store';
import { usesGlobalRiskStandardV2 } from '@/objects/mfl_global_risk.js';
import {
  getFunction_dark_mode,
  getDashboardMetricsReportTable,
  getPaginatedActionTrackerIssues,
  getSheetUpdate,
  helperGetCurrentFiscalYear,
  getFiscalYears,
  getDashboardKriSummaryTable,
  getDashboardKriReportTable,
  getDashboardKriPivotTable,
  getDashboardActionsPriorityActions,
  getDashboardActionsPriority,
  getDashboardMetricsPercentage,
  getCriticalAssetByOrganization,
  getUserAssets,
  getPwoCompliances,
  getPwoOverdues,
  getPwoCancelleds,
  getAccess,
  getStandards,
  getOrganizations,
  getImpactedAreas,

  getProfiles,
  getPermissions,
	getSpecialities,
  getRoles,
  prtFilesFilter,
  getEbits,
  getKRI,
  getDataActionTrackerTypes,
  getPublicFile1,
  getCriticalAssetByStatusValue,
  getCriticalAssetByStatusNumber,
  getDashboardMetricsSpecificHeaders,
  getCriticalAssetFileTypes,
  getAssetClass,
  getLimit,
  get_simulations_ca,
  get_simulations_sp,
 } from '@/requests/ac';

 var CryptoJS = require("crypto-js/core");
 CryptoJS.AES = require("crypto-js/aes");
 const key = '3d21f3d1gf23';
 const enc = (msj) => /* console.log('enc',{msj}, CryptoJS.AES.encrypt(msj, key).toString()) || */ CryptoJS.AES.encrypt(msj, key).toString();
 const dec = (msj) => msj?(/*  console.log('dec',CryptoJS.AES.decrypt(msj, key).toString(CryptoJS.enc.Utf8)) || */ CryptoJS.AES.decrypt(msj, key).toString(CryptoJS.enc.Utf8)):'';

Array.prototype.unique=function(a){
	return function(){return this.filter(a)}}(function(a,b,c){return c.indexOf(a,b+1)<0
});
const fN = (array, id) => {
  if (!Array.isArray(array)) {
    console.error(array, id);
    return '';
  }
  return Array.isArray(id)
    ? array
      .filter(f => id.includes(f.id))
      .map(m => m.name)
      .join(', ')
    : (array.find(f => f.id == id) || {}).name || '';
  
}
const setName = (rows, name, array, idName) => {
  rows.forEach(row => row[name] = fN(array, row[idName]))
  && rows
}


const inpAreasNames = (ids) => {
  return $store.getters.listImpactedAreas
    .filter(f => ids.find(n=>n==f.id))
    .map(m => m.full_name)
    .join(', ');
}
const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};
const getPostLoginData = () => {

  getLimit()
    .then(r => r && $store.dispatch('set', {key: 'limit', val: r?r.limit:null}));

  getAssetClass()
    .then(r => r && $store.dispatch('set', {key: 'asset_class', val: r}));

  $store.getters.requests.getsSimple['bowties'](null,{})
    .then(r => r && $store.dispatch('set', {key: 'bowties', val: r}));

  getCriticalAssetFileTypes()
    .then(r => r && $store.dispatch('set', {key: 'file_types', val: r}));

  getDashboardMetricsSpecificHeaders()
    .then(r => r && $store.dispatch('set', {key: 'dashboard_metrics_specific_headers', val: r}));

  getDashboardMetricsReportTable()
    .then(r => r && $store.dispatch('set', {key: 'dashboard_metrics_report_table', val: r}));

  
  getPaginatedActionTrackerIssues()
    .then(r => r && r.updated_at && $store.dispatch('set', {key: 'paginated_action_tracker_issues', val: r}));

  getSheetUpdate('metrics')
    .then(r => r && r.updated_at && $store.dispatch('set', {key: 'sheet_update_metrics', val: r.updated_at}));
  getSheetUpdate('action_tracker_issues')
    .then(r => r && r.updated_at && $store.dispatch('set', {key: 'sheet_update_action_tracker_issues', val: r.updated_at}));
  getSheetUpdate('actions')
    .then(r => r && r.updated_at && $store.dispatch('set', {key: 'sheet_update_actions', val: r.updated_at}));
  getSheetUpdate('kri')
    .then(r => r && r.updated_at && $store.dispatch('set', {key: 'sheet_update_kri', val: r.updated_at}));

  const rqCFY = helperGetCurrentFiscalYear()
    .then(r => r && $store.dispatch('set', {key: 'current_fiscal_year', val: r}) && r);

  getFiscalYears()
  .then(r => r && $store.dispatch('set', {key: 'fiscal_years', val: r}));

  getDashboardKriSummaryTable()
    .then(r => r && $store.dispatch('set', {key: 'kri_summary_table', val: r}));

  getDashboardKriReportTable()
    .then(r => r && $store.dispatch('set', {key: 'kri_report_table', val: r}));

  getDashboardKriPivotTable()
    .then(r => r && $store.dispatch('set', {key: 'kri_pivot_table', val: r}));

  getDashboardActionsPriorityActions()
    .then(r => r && $store.dispatch('set', {key: 'dashboard_actions_priority_actions', val: r}));
  getDashboardActionsPriority()
    .then(r => r && $store.dispatch('set', {key: 'dashboard_actions_priority', val: r}));

  getDashboardMetricsPercentage()
    .then(r => r && $store.dispatch('set', {key: 'dashboard_metrics_percentage', val: r}));

  getCriticalAssetByStatusValue()
    .then(r => r && $store.dispatch('set', {key: 'critical_asset_by_status_value', val: r}));

  getCriticalAssetByStatusNumber()
    .then(r => r && $store.dispatch('set', {key: 'critical_asset_by_status_number', val: r}));

  getCriticalAssetByOrganization()
    .then(r => r && $store.dispatch('set', {key: 'critical_asset_by_organization', val: r}));
  getDataActionTrackerTypes()
    .then(r => r && $store.dispatch('set', {key: 'data_action_tracker_types', val: r}));

  getPublicFile1()
    .then(r => r && $store.dispatch('set', {key: 'publicFile1', val: r}));
 
  getKRI()
    .then(r => {
      if (r && r.count) {
        $store.dispatch('assign', {key: 'KRI', val: r});
        const {KRINavegation} = $store.getters;
        //console.log({KRINavegation})
        KRINavegation.pages = r.count / KRINavegation.page_size;
        $store.dispatch('assign', {key: 'KRINavegation', val: KRINavegation});
      }
    });

  /* getPrtFiles */
  prtFilesFilter()
    .then(r => {
      if (r && r.count) {
        $store.dispatch('assign', {key: 'prtFiles', val: r});
        const {prtNavegation} = $store.getters;
        //console.log({prtNavegation})
        prtNavegation.pages = r.count / prtNavegation.page_size;
        $store.dispatch('assign', {key: 'prtNavegation', val: prtNavegation});
      }
    });
  getFunction_dark_mode()
    .then(r => r && $store.dispatch('set', {key: 'dark', val: r.dark_mode }));
  getRoles({is_deleted: false})
    .then(r => r && $store.dispatch('set', {key: 'roles', val: r}));

  /* getActions()
    .then(r => r && $store.dispatch('set', {key: 'actions', val: r})); */

  getProfiles({is_deleted: false})
    .then(r => r && $store.dispatch('set', {key: 'profiles', val: r}));
  getPermissions()
    .then(r => r && $store.dispatch('set', {key: 'permissions', val: r}));
    
  getPwoCancelleds()
    .then(r => r && $store.dispatch('set', {key: 'pwoCancelleds', val: r}));
  getPwoOverdues()
    .then(r => r && $store.dispatch('set', {key: 'pwoOverdues', val: r}));
  getPwoCompliances()
    .then(r => r && $store.dispatch('set', {key: 'pwoCompliances', val: r}));

  $store.getters.requests.getsSimple['workflows'](null,{approbation_date__isnull:true,status:1})
    .then(r=>{
      $store.dispatch('set', {key: 'getWorkflowNull', val: true});
      $store.dispatch('set', {key: 'pendingWfs', val: r});
    })
  /* getUsers()
    .then(r => r && $store.dispatch('set', {key: 'users', val: r})); */

  /* getTrackActivities()
    .then(r => r && $store.dispatch('set', {key: 'trackActivities', val: r})); */

  getUserAssets()
    .then(r => r && $store.dispatch('set', {key: 'userAssets', val: r}));


/*   const rqSP = getSpareParts()
    .then(rows => {
      if(rows) {
        rows.forEach(row => {
          row.critical_asset_name = '';
          set_default_atrs(row);
          set_max_mfl_atrs(row);
          row.state = row.state || 0;
        });
        const spareParts = [];
        const sparePartsDeleted = [];
        rows.forEach(r => r.is_deleted ? sparePartsDeleted.push(r) : spareParts.push(r));
        $store.dispatch('set', {key: 'spareParts', val: spareParts});
        $store.dispatch('set', {key: 'sparePartsDeleted', val: sparePartsDeleted});
      }
      return rows;
    }); */
  const rqSP_s = get_simulations_sp({is_deleted:false})
    .then(sparePart => {
      if(sparePart) {
        sparePart.forEach(row => {
          row.critical_asset_name = '';
          set_default_atrs(row);
          set_max_mfl_atrs(row);
        });
        $store.dispatch('set', {key: 'simulations_sp', val: sparePart});
      }
      return sparePart;
    });

  /* const rqCA = getCriticalAssets()
    .then(rows => {
      if(rows) {
        rows.forEach(row => {
          row.spareParts = [];
          set_default_atrs(row);
          set_max_mfl_atrs(row);
          row.state = row.state || 0;
        });

        const criticalAssets = [];
        const criticalAssetsDeleted = [];
        rows.forEach(r => r.is_deleted ? criticalAssetsDeleted.push(r) : criticalAssets.push(r));
        $store.dispatch('set', {key: 'criticalAssets', val: criticalAssets})
        $store.dispatch('set', {key: 'criticalAssetsDeleted', val: criticalAssetsDeleted})

        //rqSP.then(a => setName(a, 'critical_asset_name', rows, 'critical_asset'));
      }
      return rows;
    }); */

  /* const rqCA_s = get_simulations_ca({is_deleted:false})
    .then(criticalAssets => {
      if(criticalAssets) {
        criticalAssets.forEach(row => {
          row.spareParts = [];
          set_default_atrs(row);
          set_max_mfl_atrs(row);
        });

        $store.dispatch('set', {key: 'simulations_ca', val: criticalAssets})
      }
      return criticalAssets;
    }); */
    

/*   rqSP
    .then(a => {
      rqCA
        .then(rows => 
          rows.forEach(row => row.spareParts = a.filter(f => f.critical_asset.includes(row.id)))
          && rows
        )
      return a;
    });
 */


  getOrganizations()
    .then(r => r && !!r.length && $store.dispatch('set', {key: 'organizations', val: r}) && r)
    .then(a => {
      //rqCA.then(rows => setName(rows, 'organization_name', a, 'organization'));
      //rqSP.then(rows => setName(rows, 'organization_name', a, 'organization'));

      //rqCA_s.then(rows => setName(rows, 'organization_name', a, 'organization'));
      rqSP_s.then(rows => setName(rows, 'organization_name', a, 'organization'));
      return a;
    });

  getSpecialities()
		.then(r => r && !!r.length && $store.dispatch('set', {key: 'specialities', val: r}) && r)
    .then(a => {
      //rqCA.then(rows => setName(rows, 'speciality_name', a, 'speciality'));
      //rqSP.then(rows => setName(rows, 'speciality_name', a, 'speciality'));

      //rqCA_s.then(rows => setName(rows, 'speciality_name', a, 'speciality'));
      rqSP_s.then(rows => setName(rows, 'speciality_name', a, 'speciality'));
      return a;
    });

  getStandards({is_deleted: false})
		.then(r => r && !!r.length && $store.dispatch('set', {key: 'standards', val: r}) && r)

  getEbits({is_deleted: false})
    .then(resEbit => {
      if (!(resEbit && !!resEbit.length)) return resEbit;
      $store.dispatch('set', {key: 'ebits', val: resEbit})
      
      const ebits = resEbit;
      getImpactedAreas()
        .then(r => {
          if (r && r.length) {
            rqCFY
              .then(cfy => {
                setImpactedAreasValues(r, ebits, cfy.year);
                $store.dispatch('set', {key: 'listImpactedAreas', val: r});
              })

          } // if
          return r;
        })
        .then(a => {
          /* rqCA
            .then(rows => rows.forEach(row => row.impacted_areas_names = inpAreasNames(row.impacted_areas)) && rows); */
          /* rqSP
            .then(rows => rows.forEach(row => row.impacted_areas_names = inpAreasNames(row.impacted_areas)) && rows); */

          //rqCA_s.then(rows => rows.forEach(row => row.impacted_areas_names = inpAreasNames(row.impacted_areas)) && rows);
          rqSP_s
            .then(rows => rows.forEach(row => row.impacted_areas_names = inpAreasNames(row.impacted_areas)) && rows);
          return a;
        });
      return resEbit;
    })


}; //

const set_default_atrs = (item) => {
  item.organization_name = '';
  item.speciality_name = '';
  item.standard_name = '';
  item.impacted_areas_names = '';
  item.workflow = [];
  item.discharge_files = [];
}

const mfl_name = {
  mfl_health_and_safety:'Salud y seguridad',
  mfl_environment:'Medioambiente',
  mfl_community:'Comunidad',
  mfl_legal:'Reputación/Legal',
  mfl_reputation:'Reputación',
  mfl_sustainability:'Sustentabilidad',
  mfl_financial:'Financiero',
}
const mflKeysForVersion = (globalRiskStandardVersion) => {
  if (usesGlobalRiskStandardV2(globalRiskStandardVersion)) {
    return ['mfl_health_and_safety', 'mfl_legal', 'mfl_sustainability', 'mfl_reputation', 'mfl_financial'];
  }
  return ['mfl_health_and_safety', 'mfl_environment', 'mfl_community', 'mfl_legal', 'mfl_reputation', 'mfl_financial'];
};
const set_max_mfl_atrs = (item) => {
  item.max_mfl = maxMfl({asset:item, mfl_financial:item.mfl_financial});
  item.max_impact_name = [];

  mflKeysForVersion(item.global_risk_standard_version).forEach(key => item[key] === item.max_mfl && (item.max_impact_name.push(mfl_name[key])));
  item.max_impact_name = item.max_impact_name.unique();
  item.max_impact_name_j = item.max_impact_name.join(', ');
  return item
}
const setImpactedAreasValues = (r, ebits, selectedFiscalYear) => {
  
  r.forEach(ia => {
    ia.ebits = ebits.filter(ebit => ebit.impacted_area === ia.id);
    // el mismo año o menor
    let years = ia.ebits.map(m => m.fiscal_year);
    years = years.filter(f => f <= selectedFiscalYear);
    const maxY = Math.max(...years);
    const currentEbit = ia.ebits.find(f => f.fiscal_year === maxY);
    ia.currentEbit = currentEbit? currentEbit.value: 0;
  });

  return r;
}
const filterLC = (filter) => {
  const f = {...filter};
  Object.keys(f).forEach(k => ![undefined,null].includes(f[k]) && (f[k] = Array.isArray(f[k])? f[k].map(m=>(m+'').toLowerCase()): (f[k]+'').toLowerCase()) )
  return f;
}
const customFilter = (r, filters) => {
	try {
    const fl = filterLC(filters);
		let list = Object.keys(fl);
		list = list.filter(f => !!fl[f]);
    
		for (let i = 0; i< list.length; i++) {
      if ([undefined,null].includes(r[list[i]])) return false;
      if (typeof r[list[i]] === 'string') {
        const r_lc = (r[list[i]]+'').toLowerCase(); 
        if (Array.isArray(fl[list[i]]) && fl[list[i]].length) {
          if (! fl[list[i]].find(f => r_lc.includes((f+'').toLowerCase()))) return false;
        } else if (!r_lc.includes(fl[list[i]])) return false;
      }
      if (typeof r[list[i]] === 'number' || r[list[i]] == 0) {
        if (Array.isArray(fl[list[i]])) {
          if (fl[list[i]].length && !fl[list[i]].includes(r[list[i]]+'')) return false;
        }
        else if (!((r[list[i]]+'').includes(fl[list[i]]+''))) return false;
      }
      if (Array.isArray(r[list[i]])) {
        if (Array.isArray(fl[list[i]])) {
          if (fl[list[i]].length && ! r[list[i]].find(f => fl[list[i]].find(s=>((f+'').toLowerCase()).includes(s+'')))) return false;
        }
        else if (! r[list[i]].find(f => ((f+'').toLowerCase()).includes(fl[list[i]]+''))) return false;
        
        /* if (! r[list[i]].find(f => ((f+'').toLowerCase()).includes(fl[list[i]]+''))) return false; */
      }
		}
		return true;				
	} catch (e) {
		console.error(e)
		return true;
	}
}

const isEmptyArray = (array) => !array || array.length === 0;
//nuevo
const severityFactor = [10, 30, 100, 300, 1000];
//antiguo
const severityFactorOld = [1,3,10,30,100,300,1000];
const computeSeverityLevel = (mfl,gld) => gld === 'old'? (severityFactorOld[Number(mfl) -1] || 0):(severityFactor[Number(mfl) -1] || 0);

const residualKeysForVersion = (globalRiskStandardVersion) => {
  if (usesGlobalRiskStandardV2(globalRiskStandardVersion)) {
    return ['health_and_safety_residual', 'legal_residual', 'sustainability_residual', 'reputation_residual'];
  }
  return ['health_and_safety_residual', 'community_residual', 'environment_residual', 'legal_residual', 'reputation_residual'];
};

const severity = ({analyze, asset, financial_residual}) => {
  if (!analyze) return null;
  const residualValues = residualKeysForVersion(asset.global_risk_standard_version)
    .map(key => asset[key])
    .filter(value => value !== null && value !== undefined);
  residualValues.push(financial_residual);
  return computeSeverityLevel(Math.max(...residualValues, 0));
}

const maxMfl = ({asset, mfl_financial}) => {
  const values = mflKeysForVersion(asset.global_risk_standard_version)
    .map(key => asset[key])
    .filter(value => value !== null && value !== undefined);
  values.push(mfl_financial);
  return Math.max(...values, 0);
}

const type = ({asset, computed_financial_mfl}) => {
  const { mfl_environment, mfl_health_and_safety, mfl_community, mfl_legal, mfl_reputation } = asset;

  if (asset.redundant || asset.n_1) return null;

  if (mfl_environment > 4
    || mfl_community > 4
    || mfl_legal > 4
    || mfl_reputation > 4
    || computed_financial_mfl > 85) return 'Material'

  if (mfl_environment < 4
    && mfl_community < 4
    && mfl_legal < 4
    && mfl_reputation < 4
    && computed_financial_mfl < 25) return null;

  if (
      (
        mfl_environment < 5
        &&  mfl_community < 5
        && mfl_legal < 5
        && mfl_reputation < 5
        || (
          mfl_environment === 4
          || mfl_community === 4
          || mfl_legal === 4
          || mfl_reputation === 4
          && (
              25 < computed_financial_mfl
              && computed_financial_mfl < 85
          )
        )
      )
  ) return 'ASI';
}

const financial_residual = ({ analyze, computed_financial_residual, gld, global_risk_standard_version, asset }) => {
  if (!analyze) return null;
  const version = global_risk_standard_version ?? asset?.global_risk_standard_version;
  if (gld === 'old') {
    if (computed_financial_residual >= 2500) return 7;
    if (1000 <= computed_financial_residual) return 6;
    if (250 <= computed_financial_residual) return 5;
    if (25 <= computed_financial_residual) return 4;
    if (2.5 <= computed_financial_residual) return 3;
    if (0.25 <= computed_financial_residual) return 2;
    if (computed_financial_residual < 0.25) return 1;
  }
  if (usesGlobalRiskStandardV2(version)) {
    if (computed_financial_residual >= 4000) return 5;
    if (computed_financial_residual >= 850) return 4;
    if (computed_financial_residual >= 125) return 3;
    if (computed_financial_residual >= 5) return 2;
    if (computed_financial_residual >= 0) return 1;
    return null;
  }
  if (2000 <= computed_financial_residual) return 5;
  if (250 <= computed_financial_residual) return 4;
  if (50 <= computed_financial_residual) return 3;
  if (2 <= computed_financial_residual) return 2;
  if (0 <= computed_financial_residual) return 1;
  return null;
}

const computed_financial_mfl = ({asset, ebit}) => {
  const tolerance_factor = 1;//asset.critical_asset? 1.1: 1;
  return Math.floor((Math.round(asset.mfl_days  * (asset.impact_percentage/100) * ebit * tolerance_factor * 0.575 * 100) / 100) * 100) / 100;
}

const mfl_financial = ({ computed_financial_mfl, global_risk_standard_version, asset }) => {
  if (computed_financial_mfl === null || computed_financial_mfl === undefined) return null;
  const version = global_risk_standard_version ?? asset?.global_risk_standard_version;
  if (usesGlobalRiskStandardV2(version)) {
    if (computed_financial_mfl >= 4000) return 5;
    if (computed_financial_mfl >= 850) return 4;
    if (computed_financial_mfl >= 125) return 3;
    if (computed_financial_mfl >= 5) return 2;
    if (computed_financial_mfl >= 0) return 1;
    return null;
  }
  if (2000 <= computed_financial_mfl) return 5;
  if (250 <= computed_financial_mfl) return 4;
  if (50 <= computed_financial_mfl) return 3;
  if (2 <= computed_financial_mfl) return 2;
  if (0 <= computed_financial_mfl) return 1;
  return null;
}

const computed_financial_residual = ({analyze, asset, ebit}) => {
  if (!analyze) return null;
  //si trae .critical_asset es pq es un repuesto, ese atr al critical asset q pertenece el repuesto
  const tolerance_factor = 1;//asset.critical_asset? 1.1: 1;
  return ebit && asset.r_impact_percentage && asset.residual_days
    ? Math.round(asset.residual_days * (asset.r_impact_percentage/100) * ebit * tolerance_factor * 0.575)
    : 0;
}

const ebit = ({asset, listImpactedAreas}) => {
  let TE = 0;
  if(asset.fiscal_year_ebit != undefined) {
    const {year} = ($store.getters.fiscal_years.find(f => f.id === asset.fiscal_year_ebit)||{});
    if (year) {
      const IA = asset.impacted_areas;
      const ias = listImpactedAreas.map(m=> m.ebits.find(f=>f.fiscal_year===year));
      ias.forEach(a => TE += IA.includes(a.impacted_area)? a.value: 0);
    }
    return TE;
  }else {
    const IA = asset.impacted_areas;
    listImpactedAreas.forEach(a => TE += IA.includes(a.id)? a.currentEbit: 0);
    return TE;
  }
}

const rrr = ({analyze, severity, asset}) => {
  if (!analyze) return null;
  return severity * asset.posibility;
}
// Días Límite
const due_days = ({limit, ebit, asset}) => 
  asset.impact_percentage && ebit  
  ? Math.round(limit / (ebit * (asset.impact_percentage/100) * 0.575))
  : 0;

const analyze = ({asset}) => {
  return /* asset.has_spare === true &&  */asset.redundant === false && asset.n_1 === false;
}

const spare_list = ({analyze, rrr, computed_financial_mfl,gld,maxMfl,mfl_financial}) => {
  if (!analyze) return null;
  if (maxMfl >= 4) {
    return rrr >= 90? 'CSP':'RI';
  } else {
    if (mfl_financial >= 3) {
      return rrr >= 90? 'CSP':'RI';
    }
    return 'N/A';
  }
  
  
/*   if (maxMfl < 4) return 'N/A';
  if (rrr >= 90) return 'CSP';
  if (rrr < 90) return  'RI';
  return null; */

  /* if (rrr >= 90 && computed_financial_mfl >= 25) return 'CSP';
  console.log({gld,maxMfl});
  if (gld === 'old') {
    //viejo
    if (computed_financial_mfl >= 25) return 'RI';
  } else {
    //nuevo
    if (computed_financial_mfl >= 25 && rrr < 90) return 'RI';
  }
  return 'N/A'; */
}
//import $router from '../router';
const assignAccess = async() => {
  try {
    const t = parseInt(parseJwt(dec(localStorage.getItem('AS2X'))).exp,10);
    if (new Date(t+1578567991011) > new Date()) {
      console.error('T! Vencido');
      $store.dispatch('logout');
    }
    //console.error(new Date(t+1578567991011),t);
  }
  catch(e){
    console.error('T! no existente');
    $store.dispatch('logout');
    console.error(e);
  }

  const a = await getAccess();
      
  if (a) {
    const {access} = a;
    $store.dispatch('assign',{key:'session', val:{access}});
    return true
  } else {
    console.error('no se pudo obtener token');
    return false;
  } // if
}
const even = (arr, key) => {
	// Set slice() to avoid to generate an infinite loop!
	return arr && arr.length && arr.slice().sort(function(a, b) {
	  return a[key] - b[key];
	});
}





const formalDateFormat = (date) => {
  const days = [
    'Domingo','Lunes','Martes','Miercoles','Jueves','Viernes','Sabado'
  ];
  const months = [
    'enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'
  ]
  const d = new Date(date);
  const dayW = d.getDay();
  const dayM = d.getDate();
  const month = d.getMonth();
  const year = d.getFullYear();
  return `${days[dayW]} ${dayM} de ${months[month]} del ${year}`;
}

const one_day = 1000 * 60 * 60 * 24;

const pastDays = (date) => Math.round(new Date().getTime() - date.getTime()) / (one_day); 
Date.prototype.addDays = function(days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
}

const daysPlus = (date, plus) => {
  var result = new Date(date);
  result.setDate(result.getDate() + plus);
  return result;
}
const debounce = function (func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};
const getConfig = async function ({modules, endpoints}) {
  for (const m of modules) {
    const { default:r } = await import(`@/modules/${m}/config.js`);
    r.forEach(i => endpoints.push(i));
  }  
}
const asignarIdsMenu = (menu,prevId) => {
  for(const e of menu) {  
    if(prevId) e.id = `${prevId}/${e.id}`;
    if (e.tabs) for (const t of e.tabs) t.id = `${e.id}/${t.id}`; 
    if (e.children) asignarIdsMenu(e.children,e.id);
  }
}
const recursiveCopy = (obj) => {
  if (typeof obj !== 'object') {
    console.warn(obj,' No es un objeto para copiar por esta función!');
    return obj;
  } // if
  if (obj instanceof File) return obj;
  if (obj.length === undefined) {
    const new_obj = {};
    Object.keys(obj).forEach(k => new_obj[k] = (typeof obj[k] == 'object' && obj[k] !== null) ? recursiveCopy(obj[k]) : obj[k]);
    return new_obj;
  } else {
    return obj.map(o => typeof o == 'object' ? recursiveCopy(o) : o)
  } // if
}
const same_array = (a1,a2) => a1.length === a2.length && !a1.find((e,i)=>a2[i]!==e);

      
const parse_filters = (fls) => {
  const multiple_parse_val = (v) => [v||[]].join(',');
  const filters = {};
  const exlude = [null,'',"",undefined];
  const has_val = (v) => Array.isArray(v)? v.length: !exlude.includes(v);
  fls && Object.keys(fls).forEach(key => has_val(fls[key]) && (filters[key] = Array.isArray(fls[key])?multiple_parse_val(fls[key]): fls[key]));
  return filters;
}

const get_name_config_path = (e) => e.lpath || `${e.b}/${e.altp || e.rp}/`;

const add_gets = (name,e,store,names) => {
  store.getters.navegations[name] = {page: 1, count: 0, page_size: 10, pages: 0};
  const {message,slot_key} = e;
  const rq_obj = {
    rq: false,
    status: false,
    ticking: false,
    active: false,
    name, 
    message,
    fp:`${e.b}/${e.altp || e.rp}`,
    slot_key
  };
  names && (rq_obj.names = names);
  if (e.filter_by) {
    rq_obj.filter = {};
    ((o,l)=> l.forEach(k=> typeof k === 'object'?(o[k.k]=k.v):(o[k]=null)))(rq_obj.filter,e.filter_by);
    rq_obj.last_key_filterd = null;
  }
  if (slot_key) rq_obj.synchro_list = [];
  store.getters.requestStatus.push(rq_obj);
  store.getters.requests.gets[name] = store.getters.bs.gets(get_name_config_path(e), name);
}
const p_met = {post_m:'post',patch_m:'patch',deleteRq:'delete'}
const add_bs_met = (name,e,store,met) => {
  const mk = p_met[met]||met;
  const rp = ['patch','delete'].includes(mk) ? e.rp.substring(0, e.rp. length - 4): e.rp;
  const nm = ['patch','delete'].includes(mk) ? name.substring(0, name. length - 4): name;
  store.getters.requests[mk][nm] = store.getters.bs[met](get_name_config_path({lpath:e.lpath,rp,b:e.b,altp:e.altp}), nm);
}
const add_bs_met_if_not_exists = (rp,pre_name,store,mets=[]) => {
  const e = store.getters.endpoints.find(f => f.rp == rp);
  const name = pre_name+'-'+rp;
  if (!e.name.find(f => f == name)) {
    e.name.push(name);
    mets.forEach(m=> m == 'gets' && add_gets(name,e,store) || add_bs_met(name,e,store,m) )
  }
}

function getWeekNumber(d) {
  d = new Date(+d);
  d.setHours(0, 0, 0, 0);
  d.setDate(d.getDate() + 4 - (d.getDay() || 7));
  var yearStart = new Date(d.getFullYear(), 0, 1);
  var weekNo = Math.ceil((((d - yearStart) / 86400000) + 1) / 7)
  return [d.getFullYear(), weekNo];
}

function weeksInYear(year) {
  var d = new Date(year, 11, 31);
  var week = getWeekNumber(d)[1];
  return week == 1 ? 52 : week;
}
export {
  get_name_config_path,
  weeksInYear,
  add_gets,
  add_bs_met_if_not_exists,
  parse_filters,
  same_array,
  enc,
  dec,
  recursiveCopy,
  asignarIdsMenu,
  getConfig,
  severityFactor,
  severityFactorOld,
  daysPlus,
  pastDays,
  formalDateFormat,
  even,
  assignAccess,
  fN,
  inpAreasNames,
	computeSeverityLevel,
  severity,
  maxMfl,
	type,
	financial_residual,
	computed_financial_mfl,
	mfl_financial,
	computed_financial_residual,
	ebit,
	rrr,
	due_days,
	analyze,
	spare_list,
	isEmptyArray,
	getPostLoginData,
  customFilter,
  setImpactedAreasValues,
  debounce,
  setName,
  set_max_mfl_atrs,
};
